import { render } from "./ExpenseReceiptDetailTabDocuments.vue?vue&type=template&id=1bc7f075"
import script from "./ExpenseReceiptDetailTabDocuments.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptDetailTabDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__